import { render } from "./BackBtn.vue?vue&type=template&id=1da97a9b"
import script from "./BackBtn.vue?vue&type=script&lang=js"
export * from "./BackBtn.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__